let history

export const setHistory = (aHistory) => {
  history = aHistory
}

export const getHistory = () => {
  return history
}
